import { create } from 'zustand'

import type { AvailableBrandInfo } from '../types'
import type { DeliveryZone, Slot } from '@@types'


interface DeliveryState {
  // Состояние загрузки
  loading: boolean
  loadingZones: boolean
  loadingSlots: boolean
  
  // Данные
  deliveryZones: DeliveryZone[]
  currentZone: DeliveryZone | null
  availableBrands: AvailableBrandInfo[]
  slots: Slot[]
  
  // Вычисляемые значения
  hasDelivery: boolean
  isSlotDeliveryAvailable: boolean
  isExpressDeliveryAvailable: boolean
  deliveryCost: number
  minOrderCost: number
  freeSlotDeliveryCostFrom: number
  maxSlotWeight: number
  maxExpressWeight: number
  
  // Setters
  setLoading: (loading: boolean) => void
  setLoadingZones: (loading: boolean) => void
  setLoadingSlots: (loading: boolean) => void
  setDeliveryZones: (zones: DeliveryZone[]) => void
  setCurrentZone: (zone: DeliveryZone | null) => void
  setAvailableBrands: (brands: AvailableBrandInfo[]) => void
  setSlots: (slots: Slot[]) => void
  
  // Обновление всех данных разом
  updateDeliveryData: (data: Partial<DeliveryState>) => void
}

export const useDeliveryStore = create<DeliveryState>((set) => ({
  // Initial state
  loading: true,
  loadingZones: true,
  loadingSlots: true,
  
  deliveryZones: [],
  currentZone: null,
  availableBrands: [],
  slots: [],
  
  hasDelivery: false,
  isSlotDeliveryAvailable: false,
  isExpressDeliveryAvailable: false,
  deliveryCost: 0,
  minOrderCost: 0,
  freeSlotDeliveryCostFrom: 0,
  maxSlotWeight: 0,
  maxExpressWeight: 0,
  
  // Setters
  setLoading: (loading) => set({ loading }),
  setLoadingZones: (loadingZones) => set({ loadingZones }),
  setLoadingSlots: (loadingSlots) => set({ loadingSlots }),
  setDeliveryZones: (deliveryZones) => set({ deliveryZones }),
  setCurrentZone: (currentZone) => set({ currentZone }),
  setAvailableBrands: (availableBrands) => set({ availableBrands }),
  setSlots: (slots) => set({ slots }),
  
  updateDeliveryData: (data) => set(data),
}))
